import { Component, Input } from '@angular/core';
import { NzSafeAny } from 'ng-zorro-antd/core/types';
import { IMInfoKey } from './typing';

@Component({
  selector: 'm-sidebar-menu-detail-info',
  template: `
    <m-sidebar-menu-header mHeaderTitle="文件信息"></m-sidebar-menu-header>
    <div class="m-sidebar-menu-detail-info-container">
      <ng-container *ngFor="let key of mInfoKeys">
        <div class="m-sidebar-menu-detail-info-block">
          <div class="m-sidebar-menu-detail-info-keyName">{{ key.name }}</div>
          <div class="m-sidebar-menu-detail-info-keyValue">{{ (mDetailInfo[key.key] | mTextEllipsis: 15) || '-' }}</div>
        </div>
      </ng-container>
    </div>
  `,
  host: {
    class: 'm-sidebar-menu-detail-info'
  }
})
export class MSidebarMenuDetailInfoComponent {
  @Input() mDetailInfo: NzSafeAny = {};
  @Input() mInfoKeys: IMInfoKey[] = [];
}
